import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { GuarantorInfo } from '../../interfaces/responses/guarantor.interface';

const env = environment;

@Injectable({
  providedIn: 'root',
})
export class GuarantorService {
  private http = inject(HttpClient);

  getGuarantorByToken(token: string): Observable<GuarantorInfo> {
    return this.http
      .get<GuarantorInfo>(`${env.apiUrl}/loan-guarantors/${token}/loan`)
      .pipe(catchError((error) => throwError(() => error)));
  }

  submitGuarantorForm(formData: FormData): Observable<any> {
    return this.http
      .post<any>(`${env.apiUrl}/loan-guarantors`, formData)
      .pipe(catchError((error) => throwError(() => error)));
  }

  sendSms(token: string, loanId: string): Observable<any> {
    return this.http
      .post<any>(`${env.apiUrl}/loan-guarantors/send-sms`, { token, loanId })
      .pipe(catchError((error) => throwError(() => error)));
  }
}
